import { render, staticRenderFns } from "./compRuta0.vue?vue&type=template&id=405e91e1&scoped=true&"
import script from "./compRuta0.vue?vue&type=script&lang=js&"
export * from "./compRuta0.vue?vue&type=script&lang=js&"
import style0 from "./compRuta0.vue?vue&type=style&index=0&id=405e91e1&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "405e91e1",
  null
  
)

export default component.exports